<template>
    <sa-page-layout :showModalLoading="showModalLoading" :btnRefreshVisible="true" @refresh="onRefresh" :btnRouterBackVisible="true">
        <!-- <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Piano</label>
                        <b-form-select v-model="filtroGestioneCamere.nomePiano" type="search" placeholder="Inserire piano" :options="pianiOptions" @change="onChangePiano">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona piano - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stanza</label>
                        <b-form-select v-model="filtroGestioneCamere.nomeStanza" type="search" placeholder="Inserire stanza" :options="stanzeOptions" @change="onChangeStanza">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona una stanza - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Letto</label>
                        <b-form-select v-model="filtroGestioneCamere.nome" type="search" placeholder="Inserire letto" :options="lettoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona un letto - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice Sesso</label>
                        <b-form-select v-model="filtroGestioneCamere.codiceSesso" text-field="descrizione" value-field="codice" type="search" placeholder="Inserire sesso" :options="sessoOptions" @change="onChangeSesso">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona un sesso- </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Stato Letto</label>
                        <b-form-select v-model="filtroGestioneCamere.statoAttuale" text-field="stato" value-field="stato" type="search" placeholder="Inserire sesso" :options="statoLettoOptions">
                            <template #first>
                                <b-form-select-option :value="null">- Seleziona Stato Letto -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" variant="danger" @click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template> -->

        <template slot="table-body">
            <rsa-fatturazione-dettaglio-list-component ref="RsaFatturazioneDettaglioListComponent" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-fatturazione-dettaglio-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import saPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaFatturazioneDettaglioListComponent from "../components/RsaFatturazioneDettaglioListComponent.vue";
export default {
    components: { saPageLayout, RsaFatturazioneDettaglioListComponent },
    mixins: { UtilityMixin },
    data() {
        return {
            showModalLoading: false,
            path: null,
            idRichiesta: null,
        };
    },

    mounted() {
        let me = this;
        me.idRichiesta = this.$route.query.idRichiesta;
        me.loadData();
    },
    /* computed: {
       
    }, */
    methods: {
        loadData() {
            let me = this;
            me.$refs.RsaFatturazioneDettaglioListComponent.init(me.idRichiesta);
        },
        onSubmit() {},
        onReset() {},
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
